import React from 'react'
import "../../assets/css/view/validacao/ValidarCertificado.css"
import {View, Card, FieldsDivisor, FieldsGroup, FieldDetail, InnerHtml} from 'react-template'
import {validarCertificado} from './ValidarActions'
export default class ValidarCertificado extends View {

    constructor(props) {
        super(props)

        this.state = {
            activeLoader: true,
        }
    }


    componentDidMount = () => {
        const id = this.props.params.id
        validarCertificado( id, res => {
            this.setState({activeLoader: false, certificado: res.data})
        }, error => {
            this.setState({activeLoader: false})
            this.notifyError("Erro", error)
        })
    } 
    
    
    getConteudo(){
        if(this.state.activeLoader === false && this.state.certificado !== undefined){
            return (
                <div>
                    <FieldsDivisor label="Dados do Candidato" />
                    <FieldsGroup>
                        <FieldDetail width={4} titulo="Nome" content={this.state.certificado.nome}/>
                        <FieldDetail width={4} titulo="CPF" content={this.state.certificado.cpf}/>
                    </FieldsGroup>   

                    <FieldsDivisor label="Dados do Certificado" />
                    <FieldsGroup>
                        <FieldDetail width={12} titulo="Conteúdo" content={
                            <InnerHtml html={this.state.certificado.conteudo} /> 
                        }/>
                    </FieldsGroup> 
                </div>
            )
        }

        if(this.state.activeLoader === false && this.state.certificado === undefined)
            return (
                <span>Certificado não encontrado.</span>
            )
    }

    render() {
        return ( 
            <div className="validar-certificado">
                <h3>Validar dados do Certificado</h3>
                <Card titulo="Dados do Certificado" descricao="Informações cadastradas sobre o certificado." displayLoading={this.state.activeLoader} loadingPosition='top'>
                    {this.getConteudo()}
                </Card>  
            </div> 
        )
    }
}



// WEBPACK FOOTER //
// ./src/view/validacao/ValidarCertificado.js